import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-program',
  templateUrl: './health-program.component.html',
  styleUrls: ['./health-program.component.scss']
})
export class HealthProgramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}